import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const CenterWrap = styled.div`
  display: block;
  ${customMedia.lessThan('tablet')`
    max-width: 600px;
    width:100%;
    margin: 0 auto;
  `}
`
const CenterTab = styled.div`
  margin: 64px 0 56px 0;
  line-height: 48px;
  height: 48px;
  display: flex;

  overflow: auto;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }

  ${customMedia.lessThan('tablet')`
    margin: 24px 0 26px 0;
    line-height: 32px;
    height: 32px;
  `}
`
const CenterTabContent = styled(Link)<{ padding: string; active: string }>`
  font-size: 20px;
  line-height: 48px;
  font-family: NanumSquareNeoHeavy, sans-serif;
  color: ${(props) => (props.active === 'true' ? COLOR.point1 : COLOR.gray40)};
  background: ${COLOR.point2};
  border-radius: 30px;
  margin-right: 12px;
  padding: 0 ${(props) => props.padding};
  ${customMedia.lessThan('tablet')`
    font-size: 14px;
    line-height: 32px;
    margin-right: 4px;
    padding: 0 10px;
  `}
`

export { CenterTab, CenterTabContent, CenterWrap }
